export const trimTrailingSlash = (url: string) => {
  if (url.endsWith('/')) {
    return url.substr(0, url.length - 1)
  }
  return url
}
